import { useState } from "react";
import { useAdministrationPanel } from "../../../AdministrationContext/AdministrationPanelContext";
import useAxios from "../../../../../context/AxiosContext/AxiosContext";
import { TransactionUser } from "../../../../../configurations/Axios/urls";
import { useAuth } from "../../../../../context/AuthContext/AuthContext";
const useAdvisorTransactionsContent = () => {

    const { urlsfiltered } = useAdministrationPanel();
    const { VisitaxGet } = useAxios();
    const { user, getRoutePermissions } = useAuth();


    const [TransactiondataSelected, setTransactiondataSelected] = useState({
        payload: "",
        transactionid: "",
        voucher: "",
        paymentgateway: "",
    });

    const handleTransactionSelected = (row: any) => {
        setTransactiondataSelected({
            payload: JSON.parse(row.payload),
            transactionid: row.id,
            voucher: row.voucher,
            paymentgateway: row.openpayKey,
        });
    };


    const [TransactionsList, setTransactionsList] = useState({
        headers: getRoutePermissions("/AdministrationPanel/AdvisorPanel")?.seevoucherinner ? [
            "Manual",
            "Voucher ",
            "Fecha de creación",
            "Fecha de partida",
            "Asesor",
            "Personas",
            "Cantidad",
            "Terminal",
            "Cargo por servicio",
            "Codigo de transaccion",
            "Metodo de pago",
            "Estatus"
        ]:[
            "Manual",
            "Voucher ",
            "Fecha de creación",
            "Fecha de partida",
            "Asesor",
            "Personas",
            "Cantidad",
            "Terminal",
            "Cargo por servicio",
            "Codigo de transaccion",
        ],
        data: [],
        totalSum: 0,
        numericvalue: 0,
        omitkeys: getRoutePermissions("/AdministrationPanel/AdvisorPanel")?.seevoucherinner? [
            "id",
            "updatedAt",
            "payment",
            "dateSatQ",
            "hourSatQ",
            "useridSatQ",
            "idSatQ",
            "payload",
            "comments",
            "datecreateMex",
            "imageUrl",
            "review"
        ]:[
            "id",
            "updatedAt",
            "payment",
            "dateSatQ",
            "hourSatQ",
            "useridSatQ",
            "idSatQ",
            "payload",
            "comments",
            "datecreateMex",
            "imageUrl",
            "paymentMethod",
            "voucherContinental",
            "status",
            "review"
        ],
    });

    const [TransactionsCards, setTransactionsCards] = useState({
        TransactionsUsersOBJ: {
            Title: "Transacciones",
            Value: "-",
            SecundaryValue: "Este es el total de transacciones",
            numericvalue: 0,
        },
        PaxOBJ: {
            Title: "Pax",
            Value: "-",
            SecundaryValue: "Este es el total de Pax registrados",
            numericvalue: 0,
        },
        ManualTransaction: {
            Title: "Manuales",
            Value: "-",
            SecundaryValue: "Este es el total transacciones manuales",
            numericvalue: 0,
        },
        DigitalTransaction: {
            Title: "Digitales",
            Value: "-",
            SecundaryValue: "Este es el total transacciones digitales",
            numericvalue: 0,
        },
    });
    const keysVisiblesTransactions = [
        "personas",
        "importe",
        "service_charge",
        "manual",
        "correo",
        "telefono",
        "detalles",
    ];

    const ResetData = () => {
        setTransactionsCards((prev) => ({
            TransactionsUsersOBJ: {
                ...prev.TransactionsUsersOBJ,
                Value: "-",
                numericvalue: 0,
            },
            PaxOBJ: {
                ...prev.PaxOBJ,
                Value: "-",
                numericvalue: 0,
            },
            ManualTransaction: {
                ...prev.ManualTransaction,
                Value: "-",
                numericvalue: 0,
            },
            DigitalTransaction: {
                ...prev.DigitalTransaction,
                Value: "-",
                numericvalue: 0,
            },
        }));
        setTransactionsList(prev => ({ ...prev, data: [] }))
    }


    const getTransactionUser = () => {
        const onTransactionsResponse = (response: any) => {
            if (response.status == 200) {
                const totalSum = response.data.data.totalRecords;
                const totalPerson = response.data.data.totalPerson;
                const alltransaction = response.data.data.alltransaction;
                let manual = 0;
                let digital = 0;
                alltransaction.forEach((transaction: any) => {
                    if (transaction.manual) manual++;
                    else digital++;
                });
                setTransactionsList(prev => ({
                    ...prev,
                    data: response.data.data.alltransaction,
                    totalSum: response.data.data.totalSum,
                }));
                setTransactionsCards((prev: any) => ({
                    ...prev,
                    TransactionsUsersOBJ: {
                        ...prev.TransactionsUsersOBJ,
                        Value: totalSum,
                        numericvalue: totalSum,
                    },
                    PaxOBJ: {
                        ...prev.PaxOBJ,
                        Value: totalPerson,
                        numericvalue: totalPerson,
                    },
                    ManualTransaction: {
                        ...prev.ManualTransaction,
                        Value: manual,
                        numericvalue: manual,
                    },
                    DigitalTransaction: {
                        ...prev.DigitalTransaction,
                        Value: digital,
                        numericvalue: digital,
                    },
                }));
                return;
            }
            ResetData();

        }
        const complementary = urlsfiltered.onlydates + "&id=" + user?.id
        VisitaxGet(TransactionUser + complementary, onTransactionsResponse)
    }

    const makeRequest = () => {
        ResetData();
        getTransactionUser();
    }

    return {
        makeRequest,
        TransactionsList,
        TransactionsCards,
        TransactiondataSelected,
        setTransactiondataSelected,
        handleTransactionSelected,
        keysVisiblesTransactions
    }


}
export default useAdvisorTransactionsContent;